// extracted by mini-css-extract-plugin
module.exports = {"component":"star-rating-component--1GKZ8"};